import { useTranslation } from 'react-i18next';
import Page from '@/components/Page';

const Privacy = () => {
  const { t } = useTranslation();

  return (
    <Page
      title={t('pages.privacy.title')}
    >
      <Page.Section>{t('pages.privacy.content')}</Page.Section>
    </Page>
  );
};

export default Privacy;
